import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve((to, from, next) => {
  store.dispatch('preloader/setLoading', true);
  setTimeout(() => {
    next();
  }, 250);
});

router.afterEach(() => {
  store.dispatch('preloader/setLoading', false);
});

export default router;
